"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODR_BUILD_ORIGIN = exports.IS_ODR_BUILD = exports.GAME_SCRIPT_ORIGIN = exports.CANVAS_ID = exports.CommonEvents = void 0;
var CommonEvents;
(function (CommonEvents) {
    CommonEvents["UPDATED"] = "updated";
    CommonEvents["PAUSE"] = "pause";
})(CommonEvents = exports.CommonEvents || (exports.CommonEvents = {}));
exports.CANVAS_ID = "game-canvas";
exports.GAME_SCRIPT_ORIGIN = (function () {
    var str = Array.from(window.document.getElementsByTagName("script"))
        .filter(function (s) { return s.src.indexOf("firebaseapp.com") !== -1; })
        .filter(function (s) { return s.src.indexOf("main.js"); })
        .map(function (s) { return s.src; })[0];
    if (str) {
        return str.substr(0, str.lastIndexOf("/") + 1);
    }
})() || "";
exports.IS_ODR_BUILD = false || __IS_ODR_BUILD__;
exports.ODR_BUILD_ORIGIN = (function (link) {
    return exports.IS_ODR_BUILD ? (link ? link.replace(/http:|https:/, "vkcors:") : link) : "";
})(__ODR_BUILD_ORIGIN__) || "";
//# sourceMappingURL=constants.js.map